import { isStagingOrDev } from "../app-config";

export const getCollabBaseUrl = () =>
  `https://collab${isStagingOrDev() ? "-staging" : ""}.skedsocial.com`;

export const getExternalReviewUrl = (slugId: string) =>
  `${getCollabBaseUrl()}/#/review/${slugId}`;

export const externalReviewLinkMapper = getExternalReviewUrl;
